import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";

import { Inputs } from "../../../api/inputs";
import { InputDefinition } from "../../../api/types/inputs";
import { MutationKey } from "../../../consts/mutation-keys";
import { QueryKey } from "../../../consts/query-keys";
import { useApiError } from "../../../hooks/useApiError";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { ApiHookConfig } from "../../../types/api-hook-config";
import { CafsForm } from "../../../types/cafs-form";

export const useInputDefinitionUpdate = ({ onSuccess }: ApiHookConfig) => {
  const { datasetId, id } = useParams();
  const { formatMessage } = useIntl();
  const { handleSuccess } = useApiSuccess({
    invalidate: [[QueryKey.DefinitionSection], [QueryKey.CafsDetails]],
    snackbarText: formatMessage({
      id: "ACTIONS.INPUT_DEFINITION_UPDATE_SUCCESS",
      defaultMessage: "Input definition updated successfully.",
      description: "Input definition update success message",
    }),
    onSuccessFn: onSuccess,
  });

  const { handleError, apiErrors } = useApiError();

  const mutationFn = (data: Partial<CafsForm<InputDefinition>>) => {
    return Inputs.definitionUpdate(
      { path: { datasetId: +datasetId!, inputId: +id! } },
      data,
    );
  };

  const { mutate: updateDefinition } = useMutation({
    mutationKey: [MutationKey.DefinitionUpdate, datasetId, id],
    mutationFn: mutationFn,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return { updateDefinition, apiErrors };
};
